import {useTranslation} from "react-i18next";
import {PageTemplate} from "../../../shared/layout/PageTemplate";
import {LocationList} from "./components/LocationList";

export const Locations = () => {
    const {t} = useTranslation()
    return <PageTemplate pageName={`${t('side_bar.crud')}`} title={`${t('side_bar.locations')}`}
                         content={<LocationList/>}/>
}